import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import cn from 'classnames';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import { PdfAttachment } from '../shared/PdfAttachment/PdfAttachment';
import { PromptBubble } from '../shared/PromptBubble/PromptBubble';
import styles from './UserMessage.module.scss';
export const GetUserMessageTID = (messageId)=>getTestIds(messageId);
export const UserMessage = (param)=>{
    let { content, messageId } = param;
    const { UserMessageTID } = useMemo(()=>GetUserMessageTID(messageId), [
        messageId
    ]);
    const { t } = useLocaleKeys();
    const renderInner = ()=>{
        switch(content.type){
            case 'apply':
            case 'dismiss':
                return null;
            case 'prompt':
                return {
                    inner: /*#__PURE__*/ _jsx(PromptBubble, {
                        testId: UserMessageTID.Text(),
                        children: content.text
                    })
                };
            case 'pdf-uploaded':
                var _content_fileName;
                return {
                    inner: /*#__PURE__*/ _jsxs("div", {
                        className: styles.pdfMessage,
                        children: [
                            /*#__PURE__*/ _jsx(PdfAttachment, {
                                state: "submitted",
                                fileName: (_content_fileName = content.fileName) !== null && _content_fileName !== void 0 ? _content_fileName : content.fileId,
                                rootTestId: UserMessageTID.Pdf(),
                                fileNameTestId: UserMessageTID.PdfName()
                            }),
                            content.text != null && /*#__PURE__*/ _jsx(PromptBubble, {
                                testId: UserMessageTID.Text(),
                                children: content.text
                            })
                        ]
                    })
                };
            case 'list-select-click':
            case 'list-select-result':
                {
                    const label = content.type === 'list-select-click' ? content.label : content.resolvedContact.title;
                    return {
                        inner: /*#__PURE__*/ _jsx(PromptBubble, {
                            testId: UserMessageTID.ListSelected(),
                            children: t.agenticDrafting.messages.userListSelected({
                                label
                            })
                        })
                    };
                }
        }
    };
    const rendered = renderInner();
    if (rendered == null) return null;
    const { inner, leftAligned } = rendered;
    return /*#__PURE__*/ _jsx("div", {
        "data-testid": UserMessageTID.Wrapper(),
        className: cn(styles.wrapper, leftAligned && styles.leftAligned),
        children: inner
    });
};
